export default __webpack_public_path__ + "static/media/logo_leaderpage.1a173f9e.svg";